import { constants } from "../../../../app/shared/constants";

export const graphconstants = {
    pieChartOption: {
        colors: constants.graphColors,
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false
        },
        credits: {
            enabled : false
        },
        legend: {
            enabled : true,
            floating: true,
            align: 'left',
            verticalAlign: 'top',
            itemDistance: 250,
            layout: 'vertical',
            x: 50,
            y: 0,
            width: 200,
            overlap: true
        },
        title: {
            text: '',
            align: 'center',
            verticalAlign: 'middle',
            y: 15
        },
        tooltip: {
            headerFormat: '',
            pointFormat: '{point.name}: {point.y}%'
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: false,
                    overflow: 'allow',
                    crop: false,
                    style: {
                        fontWeight: 'bold'
                    }
                },
                startAngle: -90,
                endAngle: -180,
                center: ['50%', '50%'],
                size: '75%',
                showInLegend: true
            }
        },
        series: []
    }
}